import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {MenuItem} from 'primeng/api';
import {UtilsService} from '../../../core/utils/utils.service';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {ItemNavigationService} from '../../../core/services/technique/item-navigation.service';
import {RoutemapService} from '../../../core/services/routemap.service';
import {FS_ROUTES} from '../../../core/constants';

@Component({
  selector: 'yo-modele-plc',
  templateUrl: './modele-plc.component.html',
  styleUrls: ['./modele-plc.component.scss']
})
export class ModelePlcComponent implements OnInit, OnDestroy {

  displayDialog = false;
  subActiveSecondaryRoute: Subscription;
  subroute: Subscription;

  tabMenu: MenuItem[] = [];
  tabSelectedMenu: MenuItem;

  idModeleConditionnementPlc = null;
  titleHeader = 'Modèle plc';

  hasIDistri = false;

  constructor(public utils: UtilsService,
              public auth2Svc: Auth2Service,
              private itemNavSvc: ItemNavigationService,
              private route: ActivatedRoute,
              private routeMapSvc: RoutemapService) {}

  ngOnInit(): void {
    this.initModeleConditionnementPlc();
    this.activeSecondaryRouteSubscription();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subroute);
  }

  closeDialog = () => {
    this.displayDialog = false;
  };

  initModeleConditionnementPlc = () => {
    this.subroute = this.route.data
      .subscribe((data: any) => {
        if (data.modelePlcSupplier) {
          this.idModeleConditionnementPlc = data.modelePlcSupplier.idModeleConditionnementPlc;
          if (data.modelePlcSupplier.modelePlc) {
            this.titleHeader = `Modèle plc ${data.modelePlcSupplier.modelePlc.libelle}`;
          }
          this.initTabMenuUdp();
        }
      });
  };

  initHasGestionIDistri = () => {
    this.auth2Svc.hasGestionIDistri$.subscribe((response: boolean) => {
      this.hasIDistri = response;
    });
  };

  initTabMenuUdp = () => {
    this.tabMenu = [];

    this.tabMenu.push({
      label: `Fiche identité`,
      routerLink: ['ficheidentite'],
      command: () => this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GESTION_CONDITIONNEMENTS_MODELE_PLC, this.idModeleConditionnementPlc, 'ficheidentite'])
    });
    if (this.idModeleConditionnementPlc) {
      this.tabMenu.push({
        label: `Paramétrage`,
        routerLink: ['parametrage'],
        command: () => this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GESTION_CONDITIONNEMENTS_MODELE_PLC, this.idModeleConditionnementPlc, 'parametrage'])
      });
      this.tabMenu.push({
        label: `Points de livraison`,
        routerLink: ['points-livraisons'],
        command: () => this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GESTION_CONDITIONNEMENTS_MODELE_PLC, this.idModeleConditionnementPlc, 'points-livraisons'])
      });
    }
  };

  activeSecondaryRouteSubscription = () => {
    this.subActiveSecondaryRoute = this.itemNavSvc.secondaryRoute$.subscribe(event => {
      this.tabSelectedMenu = this.itemNavSvc.activeSecondaryRoute(event, this.tabMenu);
    });
  };

}
